import { render, staticRenderFns } from "./messages-icon.vue?vue&type=template&id=c9c5bb1a"
import script from "./messages-icon.vue?vue&type=script&lang=js"
export * from "./messages-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports